.multiComboboxInput {
  --ixf-multi-combobox-input-min-width: 250px;
  --ixf-multi-combobox-icon-height: 1rem;
  --ixf-multi-combobox-icon-width: 1rem;
  --ixf-multi-combobox-input-border-weight: 1px;
  --ixf-multi-combobox-input-height: var(--ixf-input-height);

  position: relative;
  min-width: var(--ixf-multi-combobox-input-min-width);
  min-height: var(--ixf-input-height);
  height: auto;

  .label {
    &.isFloating {
      --ixf-input-label-active-offset: var(--ixf-space-2);
    }
  }

  .inputElement {
    border-left: var(--ixf-multi-combobox-input-border-weight) solid
      var(--ixf-input-border-color);
    border-right: var(--ixf-multi-combobox-input-border-weight) solid
      var(--ixf-input-border-color);

    &.lastInputElement {
      border-bottom: var(--ixf-multi-combobox-input-border-weight) solid
        var(--ixf-input-border-color);
      border-bottom-left-radius: var(--ixf-input-border-radius);
      border-bottom-right-radius: var(--ixf-input-border-radius);
    }
  }

  &.isDisabled {
    .triggerContainer {
      cursor: default;
    }
  }

  .activator {
    height: auto;
    min-height: var(--ixf-multi-combobox-input-height);
  }

  .triggerContainer {
    height: auto;
    min-height: var(--ixf-multi-combobox-input-height);
    cursor: pointer;
    width: 100%;
    position: relative;
    border-top: var(--ixf-multi-combobox-input-border-weight) solid
      var(--ixf-input-border-color);
    border-top-left-radius: var(--ixf-input-border-radius);
    border-top-right-radius: var(--ixf-input-border-radius);

    .triggerSelection {
      flex: 1 1 100%;
    }

    .iconContainer {
      flex: 1 0 auto;
      align-self: flex-start;
      padding-right: var(--ixf-input-padding-horizontal);
      padding-top: calc(
        var(--ixf-input-padding-vertical) + (var(--ixf-input-label-gap) / 2)
      );

      .toggleButton {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .toggleIcon {
        height: var(--ixf-multi-combobox-icon-height);
        width: var(--ixf-multi-combobox-icon-width);
      }

      .clearButton {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          height: var(--ixf-multi-combobox-icon-height);
          width: var(--ixf-multi-combobox-icon-width);
        }
      }
    }

    .selectionRail {
      flex: 1 1 100%;
      padding: var(--ixf-input-padding);
      align-content: flex-start;
      position: relative;
    }

    .trigger {
      align-self: center;
      cursor: pointer;
      flex: 1 1 2ch;
      min-width: 2ch;
      max-width: 100%;
      font-size: var(--ixf-input-font-size);
      line-height: var(--ixf-input-line-height);
      font-weight: var(--ixf-input-font-weight);

      &:disabled {
        cursor: default;
      }

      &:focus {
        outline: none;
      }

      &::placeholder {
        color: var(--ixf-input-placeholder-color);
      }
    }
  }

  &.isFloating {
    .selectionRail {
      padding: calc(var(--ixf-input-label-active-offset) + var(--ixf-space-3) + var(--ixf-space-4))
        var(--ixf-input-padding-horizontal)
        var(--ixf-space-4)
        var(--ixf-input-padding-horizontal);
    }
  }

  &:not(.isOpen):not(:focus-within) {
    .trigger {
      position: absolute;
      flex: 0 0 0;
      width: 0;
      min-width: 0;
      height: 0;
      margin: 0;
      padding: 0;
      border: 0;
      opacity: 0;
      overflow: hidden;
      pointer-events: none;
    }
  }

  .pillWithPrefix:has(.prefix > *) {
    --ixf-pill-padding: 0 var(--ixf-space-1) 0 2px;

    .item {
      gap: var(--ixf-space-1);
    }
  }

  .prefix {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
  }
}
